/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Use_Catalog_DismissInputs */

const cs_templates_use_catalog_dismiss = /** @type {(inputs: Templates_Use_Catalog_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zavřít`)
};

const en_templates_use_catalog_dismiss = /** @type {(inputs: Templates_Use_Catalog_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dismiss`)
};

/**
* | output |
* | --- |
* | "Dismiss" |
*
* @param {Templates_Use_Catalog_DismissInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_use_catalog_dismiss = /** @type {((inputs?: Templates_Use_Catalog_DismissInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Use_Catalog_DismissInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_use_catalog_dismiss(inputs)
	return cs_templates_use_catalog_dismiss(inputs)
});